import http from '@/communication/AuthConnection'

export default ({id, permissions}) => {
  return http.put(`/v1/permission`, {id, permissions})
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/permission/EditPermission.js